/* Settings Page — API keys, theme, language, feature toggles, notification preferences */
import { renderLanguageSelector } from '../components/LanguageSelector';
import { renderNotificationPreferences, initNotificationPreferenceToggles } from '../notifications/preferences';

export function renderSettings(): string {
  return `
    <div class="grid-2col">
      <div style="display: flex; flex-direction: column; gap: var(--space-6);">
        <div class="glass-card">
          <h3 style="margin-bottom: var(--space-4);">🔑 API Keys</h3>
          <div style="display: flex; flex-direction: column; gap: var(--space-4);">
            ${apiKeyInput('GROQ_API_KEY', 'Groq AI (Required)', 'AI morning briefs, classification')}
            ${apiKeyInput('UPSTASH_REDIS_URL', 'Upstash Redis URL (Required)', 'Cache layer')}
            ${apiKeyInput('UPSTASH_REDIS_TOKEN', 'Upstash Redis Token (Required)', 'Cache auth')}
            ${apiKeyInput('FINNHUB_API_KEY', 'Finnhub (Optional)', 'Real-time stock quotes')}
            ${apiKeyInput('OPENROUTER_API_KEY', 'OpenRouter (Optional)', 'AI fallback')}
          </div>
          <button class="glass-btn glass-btn--primary" style="margin-top: var(--space-4); width: 100%;" onclick="localStorage.setItem('imm_settings_complete','true')">💾 Save Settings</button>
        </div>
        <div id="settings-language-selector"></div>
        ${renderNotificationPreferences()}
      </div>
      <div style="display: flex; flex-direction: column; gap: var(--space-6);">
        <div class="glass-card">
          <h3 style="margin-bottom: var(--space-4);">🎨 Appearance</h3>
          <div style="display: flex; flex-direction: column; gap: var(--space-3);">
            ${toggleSetting('Dark Mode', true)}
            ${toggleSetting('Animations', true)}
            ${toggleSetting('Price Flash Effects', true)}
            ${toggleSetting('Compact Mode', false)}
          </div>
        </div>
        <div class="glass-card">
          <h3 style="margin-bottom: var(--space-4);">📊 Data & Features</h3>
          <div style="display: flex; flex-direction: column; gap: var(--space-3);">
            ${toggleSetting('ML Strategy Predictions', true)}
            ${toggleSetting('AI Morning Brief', true)}
            ${toggleSetting('Live News Feed', true)}
            ${toggleSetting('Options Chain Data', true)}
            ${toggleSetting('MCX Commodity Data', false)}
            ${toggleSetting('IPO Dashboard', true)}
            ${toggleSetting('Desktop Notifications', false)}
          </div>
        </div>
        <div class="glass-card">
          <h3 style="margin-bottom: var(--space-4);">ℹ️ About</h3>
          <div class="text-sm text-muted">
            <p><strong>India Market Monitor</strong> v1.0.0</p>
            <p style="margin-top: var(--space-2);">AI-powered Indian stock market intelligence platform.</p>
            <p style="margin-top: var(--space-2);">Open Source • MIT License</p>
          </div>
        </div>
      </div>
    </div>
  `;
}

export function initSettings(): void {
  const langEl = document.getElementById('settings-language-selector');
  if (langEl) renderLanguageSelector(langEl);
  initNotificationPreferenceToggles();
}
function apiKeyInput(id: string, label: string, desc: string): string {
  return `
    <div>
      <label class="text-sm font-semibold" for="${id}">${label}</label>
      <div class="text-xs text-muted" style="margin-bottom: var(--space-1);">${desc}</div>
      <input class="glass-input w-full" type="password" id="${id}" placeholder="Enter key..." autocomplete="off" />
    </div>`;
}
function toggleSetting(label: string, on: boolean): string {
  return `
    <div style="display: flex; justify-content: space-between; align-items: center; padding: var(--space-1) 0;">
      <span class="text-sm">${label}</span>
      <button class="glass-btn glass-btn--sm" style="min-width: 48px; ${on ? 'background: var(--color-emerald); color: white; border-color: var(--color-emerald);' : ''}">${on ? 'ON' : 'OFF'}</button>
    </div>`;
}
